import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { withPixelLineHeight } from '../../../base/styles/functions.web';
// eslint-disable-next-line lines-around-comment
// @ts-ignore
import { Tooltip } from '../../../base/tooltip';
import { FACE_EXPRESSIONS_EMOJIS } from '../../../face-landmarks/constants';
const useStyles = makeStyles()(theme => {
    return {
        labels: {
            padding: '22px 0 7px 0',
            height: 20
        },
        emojis: Object.assign({ paddingLeft: 27 }, withPixelLineHeight(theme.typography.bodyShortRegularLarge))
    };
});
const SpeakerStatsLabels = (props) => {
    const { t } = useTranslation();
    const { classes } = useStyles();
    const nameTimeClass = `name-time${props.showFaceExpressions ? ' name-time_expressions-on' : ''}`;
    return (React.createElement("div", { className: `row ${classes.labels}` },
        React.createElement("div", { className: 'avatar' }),
        React.createElement("div", { className: nameTimeClass },
            React.createElement("div", null, t('speakerStats.name')),
            React.createElement("div", null, t('speakerStats.speakerTime'))),
        props.showFaceExpressions
            && React.createElement("div", { className: `expressions ${classes.emojis}` }, Object.keys(FACE_EXPRESSIONS_EMOJIS).map(expression => (React.createElement("div", { className: 'expression', key: expression },
                React.createElement(Tooltip, { content: t(`speakerStats.${expression}`), position: 'top' },
                    React.createElement("div", null, FACE_EXPRESSIONS_EMOJIS[expression]))))))));
};
export default SpeakerStatsLabels;
